import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

export const BrandLogo = () => {
  const { logo, mobile_logo } = useAppSelector(selectBranding)

  return (
    <div className={`lk-branding_style ${!mobile_logo && 'mobile-none'}`}>
      {logo && (
        <img
          src={logo || 'https://static.proofix.ru/meets/334/37/image/RMkrPfi8DNYik64y.png'}
          alt="Logo"
          className="brand-logo"
        />
      )}

      {mobile_logo && <img src={mobile_logo} alt="Logo" className="brand-mobile-logo" />}
    </div>
  )
}
